// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__AE0Zv","testimonial":"styles_testimonial__zGcep","quoteIcon":"styles_quoteIcon__Zugeq","role":"styles_role__D_LMf"};